import TopOfferBar from "../../components/TopOfferBar/TopOfferBar";
import Header from "../../components/Header/Header";
import BestSellerSection from "../../components/BestSellerSection/BestSellerSection";
import VideoBanner from "../../components/VideoBanner/VideoBanner";
import CollectionBanner from "../../components/CollectionBanner/CollectionBanner";
import ValueComboSection from "../../components/ValueComboSection/ValueComboSection";
import PromoVideoBanner
from "../../components/PromoVideoBanner/PromoVideoBanner";
import AboutFarmFox from "../../components/AboutFarmFox/AboutFarmFox";
import BrandPromiseBanner from "../../components/BrandPromiseBanner/BrandPromiseBanner";
import BlogSection from "../../components/BlogSection/BlogSection";
import FAQSection from "../../components/FAQSection/FAQSection";
import RecommendedProductsSection
from "../../components/RecommendedProductsSection/RecommendedProductsSection";
import SEOContentSection
from "../../components/SEOContentSection/SEOContentSection";
import MediaTalksSection
from "../../components/MediaTalksSection/MediaTalksSection";
import Footer from "../../components/Footer/Footer";

function Home() {
  return (
    <>
      <TopOfferBar />
      <Header />
      <CollectionBanner />
      <BestSellerSection />
      {/* <VideoBanner/> */}
    {/* <ValueComboSection /> */}
    {/* <PromoVideoBanner /> */}
     <AboutFarmFox />
     {/* <BrandPromiseBanner /> */}
     {/* <BlogSection /> */}
     <FAQSection />
     {/* <RecommendedProductsSection /> */}
     {/* <SEOContentSection /> */}
      {/* <MediaTalksSection /> */}
    <Footer/>
    </>
  );
}

export default Home;